import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { PreviewCertificate, Certificate } from 'app/core/components/content/certificate/certificate';
import { Observable } from 'rxjs/Observable';
import { ModalSize, SmartModalService } from 'app/core/services/smart-modal.service';
import { CertificatePreviewComponent } from 'app/core/components/content/certificate/preview/certificate-preview.component';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
export class ParticipationCertificateCardConfiguration extends MaterialConfiguration {
    constructor(course: any, certificateService: CertificateService, modalService: SmartModalService) {
        super();
        this.tagType = 'participation-certificate';
        this.classType = 'Certificate';
        this.thumbnail = 'https://itpx-branded-portal-dev.s3.amazonaws.com/digital_certificate.png';
        this.subtitle = 'Digital Certificate'
        this.expired = course.expired;
        this.multiContent = false;
        this.clickable = false;
        this.target = [];
        this.links = [{
            disabled: false,
            tooltip: this.expired ? 'branded.portal.courses.assignment.ebook.download.tooltip' : null,
            url: this.expired ? '' : course.certLocation,
            text: 'branded.portal.courses.certificate.preview.text',
            type: LinkActions.ACTION,
            action: (certificateFile) => Observable.of(new PreviewCertificate(new Certificate([certificateFile])))
                .switchMap(previewCert => certificateService.getCertificateHtml(previewCert).map(body => body.data)
                    .zip(Observable.of(previewCert))) //Learner certificate id
                .switchMap(([data, previewCert]) => modalService.
                    open(CertificatePreviewComponent, { text: data, previewCert: previewCert }, 'Certificate preview', ModalSize.Lg)),

            //   certificateService.getCertificateDownloadLink(new PreviewCertificate(new Certificate([certificateFile])))
            //     .switchMap(res => certificateService.getCertificateFile(res.data.certLocation)),
        }, {
            disabled: false,
            tooltip: this.expired ? 'branded.portal.courses.assignment.ebook.download.tooltip' : null,
            url: this.expired ? '' : course.certLocation,
            text: 'branded.portal.courses.certificate.download.text',
            type: LinkActions.ACTION,
            action: (certificateFile) => certificateService.getCertificateDownloadLink(new PreviewCertificate(new Certificate([certificateFile])))
                .switchMap(res => certificateService.getCertificateFile(res.data.certLocation, certificateFile.displayName)),
            image: this.expired ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/download-inactive.svg' :
                'https://itpx-branded-portal-dev.s3.amazonaws.com/download.svg'
        }];
        // this.links = [{
        //     disabled: false, tooltip: null,
        //     url: this.clickable ? this.target : [],
        //     text: 'branded.portal.courses.certificate.view.button.text'
        // }];
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/participation-certificate-card-configuration.ts